import styled, { css } from 'styled-components';
import { Screen, Color } from 'styles';

const MediumFooterWrapperStyle = css`
  &:after {
    width: 50%;
  }
`;

const SmallFooterWrapperStyle = css`
  background-color: ${Color.Orange};
  height: auto;
  display: inline-block;
  width: 100%;
  
  &:after {
    display: none;
  }
`;

export const StyledFooterWrapper = styled.footer`
  background-color: ${Color.Black};
  border-top: 6px solid ${Color.Orange};
  height: 376px;
  position: relative;
  
  &:after {
    background-color: ${Color.Orange};
    content: '';
    display: block;
    height: 100%;
    right: 0;
    top: 0;
    position: absolute;
    width: calc(50% + 230px);
    z-index: 0;
  }
  
  ${Screen.medium(MediumFooterWrapperStyle)}
  ${Screen.small(SmallFooterWrapperStyle)}
`;

export const StyledLogoWrapper = styled.div`
  margin-left: -21px;
`;

const SmallColumnLeftStyle = css`
  background-color: ${Color.Black};
  text-align: center;
  width: 100%;
`;

const SmallColumnRightStyle = css`
  width: 100%;
`;

export const StyledColumnLeft = styled.div`
  float: left;
  
  ${Screen.small(SmallColumnLeftStyle)}
`;

export const StyledColumnRight = styled.div`
  float: right;
  padding: 30px 0 20px;
  position:relative;
  z-index: 1;
  
  ${Screen.small(SmallColumnRightStyle)}
`;

export const StyledContactInfo = styled.div`
  align-items: center;
  color: ${Color.Black};
  display: flex;
  font-size: 18.5px;
  text-align: left;
  padding: 19px 0;
  svg {
    margin-right: 10px;
    width: 40px;
    fill: ${Color.Black};
    height: 40px;
  }
  
  span {
    display: inline-block;
  }
  
  a {
    transition: all 300ms ease-in-out;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const SmallCopyrightStyle = css`
  margin-bottom: 10px;
  margin-top: 10px;
`;

export const StyledCopyright = styled.div`
  color: ${Color.White};
  margin-top: 187px;
  
  ${Screen.small(SmallCopyrightStyle)}
`;

const SmallAuthorStyle = css`
  bottom: unset;
  justify-content: center;
  position: relative;
  width: 100%;
  margin-top: 50px;
`;

export const StyledAuthor = styled.div`
  color: ${Color.White};
  display: inline-flex;
  font-size: 10px;
  vertical-align: middle;
  align-items: center;
  letter-spacing: 2px;
  position: absolute;
  bottom: -69px;
  right: 0;
  
  a {
    font-size: 8px;
    letter-spacing: 1px;
    margin-left: 5px;
    transition: color 300ms ease-in-out;
    
    &:hover {
      color: ${Color.Black};
    }
  }
  
  svg {
    fill: ${Color.White};
    width: 13px;
    margin: 0 5px;
  }
  
  ${Screen.small(SmallAuthorStyle)}
`;


// WEBPACK FOOTER //
// ./src/components/footer/footer.style.js